import React from "react";
import { useErp } from "@/context/ErpContext";
import AgentRunModal from "@/components/erp/AgentRunModal";
import SupplierAgentModal from "@/components/erp/SupplierAgentModal";
import ARReceiptAgentModal from "@/components/erp/ARReceiptAgentModal";
import AssetAgentModal from "@/components/erp/AssetAgentModal";
import AssetTransferAgentModal from "@/components/erp/AssetTransferAgentModal";
import AssetRetirementAgentModal from "./AssetRetirementAgentModal";
import MoveOrderCreateModal from "@/components/erp/MoveOrderCreation"
import TransactMoveOrder from "@/components/erp/TransactMoveOrder";
import SaleOrderAgentModal from "./SaleOrderAgentModal";
import JournalAgentModal from "./JournalAgentModal";
import ItemCreationAgentModal from "./ItemCreationAgentModal";
import FinanceAgentModal from "./FinanceAgentModal";
import MaintenanceWorkOrderCreateModal from "./MaintenanceWorkOrder";
import ManufacturingWorkOrderCreateModal from "./ManufacturingWorkOrder";

export default function AgentModalRouter() {
  const { openAgent } = useErp();

  const CHAT_ONLY_PATTERNS = [
    "account-overview",
    "account_overview",
    "finance-variance",
    "finance-account-variance",
    "finance-future",
    "future-insight",
    "finance-narrative",
    "finance-reporting-narrative",
  ];

  function isChatOnlyAgent(key) {
  if (!key) return false;
  return CHAT_ONLY_PATTERNS.some((p) => key.includes(p));
}


  if (openAgent === "supplier-create" || openAgent === "supplier-creation") {
    return <SupplierAgentModal />;
  }

  if(openAgent === "sales-order-booking"){
    return <SaleOrderAgentModal/>;
  }

  if(isChatOnlyAgent(openAgent)){
    return <FinanceAgentModal />
  }

  if (openAgent === "receipt-create") {
    return <ARReceiptAgentModal />;
  }
  

  if (openAgent === "asset-addition") {
    return <AssetAgentModal />;
  }

    if (openAgent === "asset-transfer") {
    return <AssetTransferAgentModal />;
  }

  if (openAgent === "asset-retirement") {
    return <AssetRetirementAgentModal />;
  }
  if(openAgent === "item-creation"){
    return <ItemCreationAgentModal/>
  }


  // Purchase Requisition has its own dedicated modal (PurchaseReqAgentModal),
  // mounted separately in AppLayout. Returning null here prevents the generic
  // AgentRunModal from ALSO mounting for this agent (a double-modal).
  if (openAgent === "purchase-req-create") {
    return null;
  }

  // Purchase Order has its own dedicated modal (PurchaseOrderAgentModal), for
  // the same reason as Purchase Requisition above — mounted separately in
  // AppLayout, blocked here to prevent a double-modal.
  if (openAgent === "purchase-order-create") {
    return null;
  }

  if (openAgent === "journal-create" || openAgent === "journal-creation") {
    return <JournalAgentModal />; 
  }

  //move-order-create
  if (openAgent === "move-order-create"){
    return <MoveOrderCreateModal/>
  }
  if(openAgent === "transact-move-order"){
    return <TransactMoveOrder/>
  }
  if(openAgent === "maintenance-work-order"){
    return <MaintenanceWorkOrderCreateModal/>
  }
  if(openAgent === "manufacturing-work-order"){
    return <ManufacturingWorkOrderCreateModal/>
  }

  return <AgentRunModal />;
}